var membershipApp = angular.module('membershipApp', ['ngSanitize', 'ngCookies', 'pascalprecht.translate', 'angularUtils.directives.dirPagination', 'scheduleApp'])

membershipApp.config(['$httpProvider', '$translateProvider', function ($httpProvider, $translateProvider) {
	  $httpProvider.defaults.timeout = 5000;

	 
	  //$translateProvider.translations('en', dictEN)
	  //                .translations('bg', dictBG);

	  // $translateProvider.preferredLanguage('bg');

	$translateProvider.fallbackLanguage('bg');
	$translateProvider.registerAvailableLanguageKeys(['bg', 'en', 'es', 'esc'], {
		'bg_*': 'bg',
		'en_*': 'en',
		'es_*': 'es',
		'esc_*': 'esc'
	});

	var ob_bg;
	var ob_en;
	var ob_es;
	var ob_esc;

	$.ajax({
		async: false,
		url: "../frontend/customersportal/src/translate/bg.json",
		success: function (json) {
			ob_bg = json;
		}
	});

	$.ajax({
		async: false,
		url: "../frontend/customersportal/src/translate/en.json",
		success: function (json) {
			ob_en = json;
		}
	});

	$.ajax({
		async: false,
		url: "../frontend/customersportal/src/translate/es.json",
		success: function (json) {
			ob_es = json;
		}
	});

	$.ajax({
		async: false,
		url: "../frontend/customersportal/src/translate/esc.json",
		success: function (json) {
			ob_esc = json;
		}
	});

	$translateProvider.translations('en', ob_en);
	$translateProvider.translations('bg', ob_bg);
	$translateProvider.translations('es', ob_es);
	$translateProvider.translations('esc', ob_esc);

	$translateProvider.preferredLanguage('bg');
	$translateProvider.preferredLanguage('en');
	$translateProvider.useLocalStorage();
	

}]);

var scheduleApp  = angular.module('scheduleApp', ['ngSanitize', 'pascalprecht.translate'])

scheduleApp.config(['$httpProvider', '$translateProvider', function ($httpProvider, $translateProvider) {
	$httpProvider.defaults.timeout = 5000;
	 
	//$translateProvider.translations('en', dictEN)
	//                .translations('bg', dictBG);

	//$translateProvider.preferredLanguage('bg');

	$translateProvider.fallbackLanguage('en');
	$translateProvider.registerAvailableLanguageKeys(['bg', 'en', 'es', 'esc'], {
		'bg_*': 'bg',
		'en_*': 'en',
		'es_*': 'es',
		'esc_*': 'esc'
	});

	var ob_bg;
	var ob_en;
	var ob_es;
	var ob_esc;

	$.ajax({
		async: false,
		url: "../frontend/customersportal/src/translate/bg.json",
		success: function (json) {
			ob_bg = json;
		}
	});

	$.ajax({
		async: false,
		url: "../frontend/customersportal/src/translate/en.json",
		success: function (json) {
			ob_en = json;
		}
	});

	$.ajax({
		async: false,
		url: "../frontend/customersportal/src/translate/es.json",
		success: function (json) {
			ob_es = json;
		}
	});

	$.ajax({
		async: false,
		url: "../frontend/customersportal/src/translate/esc.json",
		success: function (json) {
			ob_esc = json;
		}
	});

	$translateProvider.translations('en', ob_en);
	$translateProvider.translations('es', ob_es);
	$translateProvider.translations('esc', ob_esc);
	$translateProvider.translations('bg', ob_bg);

	$translateProvider.preferredLanguage('bg');
	$translateProvider.preferredLanguage(lang);

 }]);


$(window).on('load', function(){
	var link = location.href.split('/').pop();
	link = link.split('?');
	link = link[0].toLowerCase();
	$('.nav li[data-link="' + link + '"]').addClass('active');

	setTimeout(function() {
		$('body').addClass('loaded');
	}, 500);

	$('.menu-trigger').on('click', function(e){
		e.preventDefault();

		$('.mobile-menu .nav li.has-submenu').removeClass('open-submenu');
		$('body').toggleClass('show-menu');
	});

	$('.nav > ul > li.has-submenu > a').on('click', function(e){
		var li = $(this).parent('li');
		if( !li.is('.open-submenu') ){
			e.preventDefault();
			li.addClass('open-submenu').siblings('li.open-submenu').removeClass('open-submenu');
		}
	})
})